import { render, staticRenderFns } from "./onValidate-editor.vue?vue&type=template&id=4509c6b4&scoped=true&"
import script from "./onValidate-editor.vue?vue&type=script&lang=js&"
export * from "./onValidate-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4509c6b4",
  null
  
)

export default component.exports